import { Feather, Ionicons } from '@expo/vector-icons';
import React, { useContext } from 'react';
import { Text, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { AppContext } from '../../Context/AppContext';
import styles from './styles';

interface IReadingTextProps {
    item: string;
    index: number;
    partIndex: number;
    sectionIndex: number;
    sectionName: string;
    textSize: number;
    iconsSize: number;
}

const ReadingText = ({ item, index, partIndex, sectionIndex, sectionName, textSize, iconsSize }: IReadingTextProps) => {
    const {
        bookmark,
        setBookmark,
        saveBookmark,
        getBookmark,
    } = useContext(AppContext);

    const isUpperCase = (item.toUpperCase() === item);

    const romanNumerals = ["I.", "II.", "III.", "IV.", "V.", "VI.", "VII.", "VIII.", "IX.", "X."];
    let hasRomanNumerals = false;

    romanNumerals.forEach(numeral => {
    if (item.includes(numeral)) {
        hasRomanNumerals = true;
        return false;
    }
    });
    
    const numberPattern = /\d+\. /;
    
    let number = -1;
    const textMatch = item.match(numberPattern);
    if (textMatch != null) {
    const numberMatch = textMatch[0].match(/\d+/);
    if (numberMatch != null) {
        number = parseInt(numberMatch[0]);
    }
    }
    
    const isParagraph = numberPattern.test(item);

    const isBookmark = (bookmark?.paragraphIndex == index) && (bookmark.paragraphNumber == number);

    return (
    <View key={index} style={styles.paragraphContainer}>
        {
        isParagraph &&
        <View style={styles.paragraphOptions}>
            {/* <TouchableOpacity
            style={styles.optionButton}
            >
            <Feather name="star" size={iconsSize} />
            </TouchableOpacity> */}

            <TouchableOpacity
            style={styles.optionButton}
            onPress={() => saveBookmark(partIndex, sectionIndex, index, number, sectionName)}
            >
            <Ionicons name={isBookmark ? "bookmark" : "bookmark-outline"} size={iconsSize} />
            </TouchableOpacity>
        </View>
        }
        <Text 
            style={[
                styles.text,
                { fontSize: textSize }
            ]}
        >
        {
            isUpperCase || hasRomanNumerals
            ? <Text 
                style={[
                    styles.boldText,
                    {
                        fontSize: textSize
                    }
                ]}>
            {item}
            </Text>
            : item + '\n'
        }
        </Text>

    </View>
    );
};

export default React.memo(ReadingText);